import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { post, get, patch, del } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "notes";

export const getNotes = async (_filter: any) => {
	try {
		const endpoint = `${initialRoute}/get-notes`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			_filter
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		console.log("===>error this api", error);
	}
};

export const postNote = async (_payload: any) => {
	try {
		const endpoint = `${initialRoute}/post-note`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, _payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		console.log("===>error this api", error);
	}
};

export const updateNote = async (_payload: any) => {
	try {
		const endpoint = `${initialRoute}/update-note`;
		const token = localStorage.getItem("@jwt");
		const response = await patch(endpoint, _payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.patch.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		console.log("===>error this api", error);
	}
};
export const deleteNote = async (noteObjId: any) => {
	try {
		const endpoint = `${initialRoute}/delete-note/${noteObjId}`;
		const token = localStorage.getItem("@jwt");
		const response = await del(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.delete.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		console.log("===>error this api", error);
	}
};
